<div class="download-wrapper">
  <a [href]="getWidgetUrl" target="_blank" (click)="install()">
    <div class="store-button"></div>
  </a>
</div>
